module.exports = __webpack_public_path__ + "images/ext-link.bf773cf68e.svg";